import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { CustomMaterialModule } from './custom-material/custom-material.module';
import { AppRoutingModule } from './app-routing.module';
import { LoggerModule } from 'ngx-logger';
import { environment } from '../environments/environment';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { FeatureService } from './core/services/feature.service';
registerLocaleData(localeFr);

export function initFeatures(fs: FeatureService): () => Promise<any> {
    return () => fs.loadFeatures().toPromise();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
      BrowserModule,
      MDBBootstrapModule.forRoot(),
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    CustomMaterialModule.forRoot(),
    AppRoutingModule,
    LoggerModule.forRoot({
      serverLoggingUrl: `http://my-api/logs`,
      level: environment.logLevel,
      serverLogLevel: environment.serverLogLevel
    })
  ],
    bootstrap: [AppComponent],
    providers: [
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        {
            provide: APP_INITIALIZER,
            useFactory: initFeatures,
            deps: [FeatureService],
            multi: true
        }
    ]
})
export class AppModule { }
